module.exports = __webpack_public_path__ + "img/zk-icon-discount.1c7a7f3a.svg";